import { trpc } from '@/data-loaders';

export const useSchoolUnitList = (schoolId: number) => {
  return trpc.schoolUnit.getSchoolUnitList.useQuery(
    { schoolId },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!schoolId,
    },
  );
};
